import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgAlertComponent } from './dlg-alert.component';

@Injectable()
export class AlertService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show({ data }: any): Promise<any> {
        const dialogRef = this._dialog.open(DlgAlertComponent, {
            panelClass: ['--ui'],
            data
        });

        const source = dialogRef.afterClosed();
        const continue$ = source
            .pipe(filter<boolean>((val) => val === true))
            .pipe(switchMap(async () => data.continue && await data.continue()));
        const close$ = source
            .pipe(filter((val) => val !== false && val !== true))
            .pipe(switchMap(async () => data.close && await data.close()));
        const cancel$ = source
            .pipe(filter((val) => val === false))
            .pipe(switchMap(async () => data.cancel && await data.cancel()));

        return merge(continue$, close$, cancel$).toPromise();
    }
}
